import React from 'react';
import Routes from './Routes';

const App = () => {
  // console.log(
  //   `ikea-food-prototype build time: ${process.env.REACT_APP_BUILD_TIME}`
  // );
  return (
   
            <Routes />
  );
};

export default App;
